import { faSignalBarsFair, faSignalBarsGood, faSignalBars, faSignalBarsWeak } from '@fortawesome/pro-duotone-svg-icons';
import { SkillMatrixSegment } from 'src/common/components/skill-matrix-graphic/skill-matrix-graphic.types';
export const SEGMENTS_OPTIONS = ([{
  id: SkillMatrixSegment.ENTRY,
  label: 'Entry level',
  value: SkillMatrixSegment.ENTRY,
  icon: faSignalBarsWeak
}, {
  id: SkillMatrixSegment.JUNIOR,
  label: 'Junior',
  value: SkillMatrixSegment.JUNIOR,
  icon: faSignalBarsFair
}, {
  id: SkillMatrixSegment.MID,
  label: 'Mid level',
  value: SkillMatrixSegment.MID,
  icon: faSignalBarsGood
}, {
  id: SkillMatrixSegment.SENIOR,
  label: 'Senior',
  value: SkillMatrixSegment.SENIOR,
  icon: faSignalBars
}] as const);